import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoaderService } from "src/app/services/loader/LoaderService";
import { Globals } from "src/environments/Globals";
import { CommonConstant } from "src/app/shared/constent/applicationcodes";
import { AuthService } from "../authentication/authentication-helpers/auth.service";

declare var $: any;

@Component({
    templateUrl: 'modules.component.html',
    styleUrls: ['./modules.component.css']
})
export class ModulesComponent implements OnInit {
    modules: any[] = [];
    categorySubtitle = 'Select a module to manage your business with ease.';
    private const = new CommonConstant();

    constructor(
        private loaderService: LoaderService,
        private route: Router,
        private globals: Globals,
        private authService: AuthService
    ) { }

    ngOnInit() {
        if (localStorage.getItem('isLoggedIn') !== 'true') {
            this.route.navigate(['/Login']);
            return;
        }

        $("body").addClass("loginbody");
        $("html").removeAttr("dir");

        this.loaderService.display(true);
        this.loadModules();
        this.loaderService.display(false);
    }

    loadModules() {
        const menuJson = this.globals.getDataFromLocalStorage(this.const.AllowedMenus);

        if (!menuJson) {
            this.route.navigate(['/Login']);
            return;
        }

        const menu = JSON.parse(menuJson);
        this.modules = this.parseFlatArrayToTreeArray(menu);
    }

    parseFlatArrayToTreeArray(list: any): any[] {
        const treeArray = list.filter(x => x.PageLevel == 0 && x.IsParent == 1);

        treeArray.forEach((element) => {
            element.Visible = false;
            element.Child = list.filter(x => x.ParentID === element.PageID && x.PageLevel == 1);

            element.Child.forEach((childElement) => {
                childElement.Child = list.filter(x => x.ParentID === childElement.PageID && x.PageLevel == 2);
                if (childElement.Child && childElement.Child.length > 0) {
                    element.Visible = true;
                }
            });
        });

        return treeArray;
    }

    getModuleTitle(module: any): number {
        return module.StringNumber;
    }

    openModule(module: any) {
        this.globals.setDataInLocalStorage(this.const.CurrentModuleID, module.ModuleID);
        this.route.navigate(['Dashboard']);
    }

    backToLogin() {
        this.authService.logout();
    }
}
